import React from 'react';

import Panel from '@repo/ui/components/layout/Panel';
import AlertBlock from '../widgets/AlertBlock';
import { Paragraph } from '@repo/ui/components/typography/Content';
import Buttons from '@repo/ui/components/buttons';
import { useTranslation } from 'react-i18next';

export default function AlreadyLoggedIn({ socialError, user }) {
  const { t } = useTranslation(['common', 'commonPlat']);

  return (
    <div style={{ textAlign: 'center' }}>
      <Panel>
        {socialError ? (
          <AlertBlock style="warning" title={socialError} />
        ) : (
          <Paragraph>
            {t('common:alerts.alreadyLoggedInAsName', {
              name: `${user.firstName} ${user.lastName}`,
            })}
          </Paragraph>
        )}

        <Buttons.Primary to={`/dashboard`}>{t('common:actions.goToNewsFeed')}</Buttons.Primary>
      </Panel>
      <Buttons.Alternate to={`/logout`}>{t('commonPlat:actions.logout')}</Buttons.Alternate>
    </div>
  );
}
